/**
 * Cookie law functions.
 */
import GlobalVars from '../GlobalVars';
import * as headerDesktop from '../../desktop/organism/header';
import * as headerMobile from '../../mobile/organism/header';
import {
  createCookie,
  readCookie,
} from '../tools/Cookie';

const idCookiesLaw = '#cookieslaw';
const BtnCookiesLaw = '.js-close-cookieslaw';
const cookieName = `cookieslaw-${GlobalVars.Brand}-${GlobalVars.C}`;

/**
 * Handles the cookies law.
*/

function removeCookiesLawBlock() {
  $(idCookiesLaw).remove();
}

function handleCookiesLaw() {
  $(BtnCookiesLaw).on('click', () => {
    // Remove cookies block on button click
    removeCookiesLawBlock();

    // Reset header height style
    if (GlobalVars.IsMobile) {
      headerMobile.init();
    } else {
      headerDesktop.init();
    }

    // Add new cookie
    createCookie(
      cookieName,
      '1',
      365
    );
  });

  // Remove block if cookie exist
  if (readCookie(cookieName)) {
    removeCookiesLawBlock();
  } else {
    $(idCookiesLaw).addClass('active');
  }
}

/**
* Init
*/
function init() {
  handleCookiesLaw();
}

export default init;



// WEBPACK FOOTER //
// ./js/common/molecule/cookies-law.js